import { TAB_STATUS } from '../../../../constants';
import { getWozObjectData } from '../../../../services/utilities/apis/woz';
import { getBagVboFeatureInfoFromFilters } from '../../../../services/map/feature/selection';
import { isPointInsideOrgPolygonOrBBox } from '../../../../services/map/boundingBox';

const store = {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        async getWozData({ dispatch, getters, commit }, { data, title }) {
            // Clear possible results for this title and open new tab with status Loading
            dispatch('initTabObjectSearch', { title });
            try {
                const result = await dispatch('useApiData', {
                    name: 'GetWozData',
                    data
                });
                const wozData = getWozObjectData(result.data);

                // only select/zoom in if
                // - 1 item is found (because of technical problem in underlying PDOK BAG WFS service)
                // - when data has adresseerbaarObjectIdentificatie
                let features = [];
                let pointInsideBbox = true;
                if (wozData.items?.length === 1 && wozData.items[0].adresseerbaarObjectIdentificatie) {
                    features = await dispatch('getWozVboFeaturesFromBag', { data: wozData });
                    if (features.length > 0) {
                        pointInsideBbox = isPointInsideOrgPolygonOrBBox(getters.getUserData, features[0].getGeometry());
                    }
                }

                commit('UPDATE_LOADING_OBJECT_DATA', {
                    title,
                    data: wozData,
                    count: result.data?.length ?? 0,
                    exportable: true,
                    download: true,
                    printable: true,
                    features,
                    zoomToFeatures: pointInsideBbox, // only zoom to feature if it is inside the bbox
                    pointInsideBbox,
                    wozData: true,
                    status: TAB_STATUS.READY
                });
                dispatch('trackUserEvent', { name: 'getWozData' });
            } catch (err) {
                commit('UPDATE_LOADING_OBJECT_DATA', {
                    title,
                    data: {
                        'items': [],
                        'fields': []
                    },
                    maxResultsExceeded: false,
                    count: 0,
                    status: TAB_STATUS.ERROR,
                    message: err.message
                });
            }
        },

        async getWozVboFeaturesFromBag(store, { data }) {
            const items = data.items.map(item => {
                return {
                    filterAttribute: 'identificatie',
                    value: item?.adresseerbaarObjectIdentificatie
                };
            });
            return getBagVboFeatureInfoFromFilters(
                store,
                items,
                false
            );
        }
    }
};

export default store;
